<script setup lang="ts" generic="T extends string">
defineProps<{ options: { value: T; label: string }[] }>();

const model = defineModel<T>({ required: true });
</script>

<template>
  <div
    class="no-scrollbar bg-creux flex max-w-full items-center gap-1 overflow-x-auto rounded-[24px] p-1"
  >
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="flex h-10 shrink-0 cursor-pointer items-center justify-center rounded-[20px] px-3 text-[14px] leading-[1.4] whitespace-nowrap xl:px-5"
      :class="
        model === option.value
          ? 'bg-carte text-encre font-semibold'
          : 'text-encre-douce'
      "
      :aria-pressed="model === option.value"
      @click="model = option.value"
    >
      {{ option.label }}
    </button>
  </div>
</template>
